import { Box, Container, Divider, Link as LinkMUI, Typography } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useTheme, styled } from '@mui/styles';

export interface FooterProps {
  containerMaxWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false;
  className?: string | undefined;
  privacyPolicyUrl?: string;
  termsUrl?: string;
  doNotSellUrl?: string;
}

const FooterLink = styled(LinkMUI)(({ theme }) => ({
  marginLeft: theme.spacing(3),
  '&:hover': { color: 'inherit', opacity: 0.8 },
}));

const Footer = ({
  containerMaxWidth,
  className,
  privacyPolicyUrl = process.env.NEXT_PUBLIC_PRIVACY_POLICY_EXTERNAL_URL,
  termsUrl = process.env.NEXT_PUBLIC_TERMS_EXTERNAL_URL,
  doNotSellUrl = process.env.NEXT_PUBLIC_VEEVA_CCPA_EXTERNAL_URL,
}: FooterProps) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box mt={3} className={className}>
      <Divider />
      <Container maxWidth={containerMaxWidth}>
        <Box display="flex" alignItems="center" height={63}>
          <Box flexGrow={1} textAlign="right" py={2} display="flex" justifyContent="flex-end" flexDirection={mdUp ? 'row' : 'column'}>
            <Typography variant="body2" mt={mdUp ? 0 : 0.6}>
              &copy; Copyright {new Date().getFullYear()} Veeva Systems
            </Typography>
            <Box textAlign="right" ml={2} display="flex" flexDirection={mdUp ? 'row' : 'column'}>
              <FooterLink color="inherit" href={doNotSellUrl} target="_blank" variant="body1" mt={mdUp ? 0 : 0.375} mb={mdUp ? 0 : 0.75}>
                Do not sell my personal information
              </FooterLink>
              <Box>
                <FooterLink color="inherit" href={privacyPolicyUrl} target="_blank" variant="body1">
                  Privacy Policy
                </FooterLink>
                <FooterLink color="inherit" variant="body1" href={termsUrl} target="_blank">
                  Terms
                </FooterLink>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
